import { render, staticRenderFns } from "./PlgAccountBalance.vue?vue&type=template&id=d2e177e6&"
import script from "./PlgAccountBalance.vue?vue&type=script&lang=js&"
export * from "./PlgAccountBalance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports